import { BaseResultModel } from './base-result.model';

export class QrCodeModel extends BaseResultModel {
  Id = 0;
  IsPdf = false;
  Base64Result = '';
  Filename = '';
  DownloadLabel = ''
}
